'use strict';

angular.module('prism-ui.components').service('TranslatableMetadataService', function (
    this: JS5Object,
    $q: JS5Object,
) {
    let dataObjectDeferred = $q.defer();
    this.dataObjectPromise = dataObjectDeferred.promise;


    this.resetDataObjectPromise = () => {
        dataObjectDeferred = $q.defer();
        this.dataObjectPromise = dataObjectDeferred.promise;
    };

    this.setDataObject = (dataObject: JS5Object) => {
        dataObjectDeferred.resolve(dataObject);
    }

    this.dataObjectSaved = (newDataObject: JS5Object) => {
        this.resetDataObjectPromise();
        this.setDataObject(newDataObject);
        this.onSave();
    }

    this.dataObjectReverted = (newDataObject: JS5Object) => {
        this.resetDataObjectPromise();
        this.setDataObject(newDataObject);
        this.onRevert();
    }

    this.preSave = () => {}
    this.onSave = () => {}
    this.onRevert = () => {}

});
